import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import dayjs from "dayjs";
import { Link } from "react-router-dom";

const PositionCell = (props: GridCustomCellProps) => {
  if (!props.field) return null;

  return (
    <td {...props.tdProps}>
      <Link style={{ color: "#007bff" }} to={`/Assets/Vehicle/${props.dataItem.VehicleID}/Positions`}>{props.dataItem.PositionCityInfo}</Link>
      {props.dataItem.PositionDateTime && <div style={{ fontSize: '11px' }}>{dayjs.utc(props.dataItem.PositionDateTime).tz("America/New_York").format("MM/DD/YYYY HH:mm")}</div>}
    </td>
  );
}

export default React.memo(PositionCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);
